import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { FullComponent } from './layouts/full/full.component';
import { LoginComponent } from './login/login.component';

export const profilePaths = ['originator'];

export const Approutes: Routes = [
  {
    path: '',
    component: FullComponent,
    children: [
      { path: '', redirectTo: '/bank', pathMatch: 'full' },

      {
        path: 'bank',
        loadChildren: () => import('./transaction/transactions.module').then((m) => m.TransactionsModule),
        canActivate: [MsalGuard],
      },


    ],
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: '**',
    redirectTo: '/bank',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(Approutes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
